module.exports = __webpack_public_path__ + "img/client-logo-apache.384f3264.png";